jQuery(document).ready(function($) {

	var wW = $(window).width();

	// mobile menu toggle
	$('.menu-toggle').click(function() {
		$('.nav-bar').toggle();
        $('html').toggleClass('hide-scroller');
	});

	if ( wW <= 962 && wW > 768 ) {
		$('ul.sm-simple > li.has-dropdown > a').click(function(e) {

			e.preventDefault();
			if( $(this).parent().hasClass('active') ) {
				$(this).parent().removeClass('active');
			} else {
				$(this).parent().addClass('active').siblings().removeClass('active');
			}
			e.stopImmediatePropagation();
		});
	}

      	$('body').on('click', 'ul.sm-simple li[class*="has-dropdown"] > div', function(e) {
          	var li = $(this).parent();
			if( li.hasClass('active') ) {
				li.toggleClass('active');
			}else{
				li.addClass('active').siblings().removeClass('active');
			}
			e.stopImmediatePropagation();
		});


	// mega-nav custom scripts
  if ( wW <= 768 ) {
      	$('body').on('click', 'ul.sm-simple li[class*="has-dropdown"] > a', function(e) {
          	e.stopImmediatePropagation();
          	var href = $(this).attr('href');
			if( href == '#' ) {
              	var li = $(this).parent();
				if( li.hasClass('active') ) {
					li.removeClass('active');
                }else{
					li.addClass('active').siblings().removeClass('active');
				}
			}
		});
	}
  
	$('.mega-nav li.has-mega-dropdown > .mega-wrapper').css('width', wW);
	$(window).resize(function() {
		var wWr = $(window).width();
		if ( wWr > 768 ) {
			$('.mega-nav li.has-mega-dropdown > .mega-wrapper').css('width', wWr);
			$('li.has-dropdown.bottom').remove();
		} else {
			$('.mega-nav li.has-mega-dropdown > .mega-wrapper').css('width', 'auto');
        }
      
      	if ( wWr <= 768 ) {
      	$('body').on('click', 'ul.sm-simple li[class*="has-dropdown"] > a', function(e) {
          	e.stopImmediatePropagation();
          	var href = $(this).attr('href');
			if( href == '#' ) {
              	var li = $(this).parent();
				if( li.hasClass('active') ) {
					li.removeClass('active');
                }else{
					li.addClass('active').siblings().removeClass('active');
				}
			}
		});
	}
	});

});